import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../../shared/utils/formatCurrency";

function fmtDate(iso) {
  if (!iso || iso.length < 10) return iso ?? "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
}

function PillBtn({ icon, label, color, hoverBg, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 30,
        height: 30,
        padding: 0,
        background: `${color}1a`,
        border: `1px solid ${color}4d`,
        borderRadius: 6,
        color,
        fontSize: "0.85rem",
        cursor: "pointer",
        transition: "background 0.15s, border-color 0.15s",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.background = hoverBg;
        e.currentTarget.style.borderColor = color;
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.background = `${color}1a`;
        e.currentTarget.style.borderColor = `${color}4d`;
      }}
    >
      <i className={`fa-solid ${icon}`} />
    </button>
  );
}

export default function ReceiptRow({
  receipt,
  onEdit,
  onDelete,
  onEmail,
  selected = false,
  onToggleSelect,
}) {
  const { t } = useTranslation();
  const id = receipt.id;

  const METODO_LABEL = {
    TRANSFERENCIA: t("recibos.transferencia"),
    EFECTIVO:      t("recibos.efectivo"),
    CHEQUE:        t("recibos.cheque"),
  };

  return (
    <tr style={{ background: selected ? "rgba(249,115,22,0.06)" : undefined }}>
      {/* Checkbox */}
      <td
        style={{ width: 36, paddingRight: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          type="checkbox"
          checked={selected}
          onChange={() => onToggleSelect?.(id, receipt)}
          style={{ cursor: "pointer", accentColor: "#f97316" }}
        />
      </td>

      <td style={{ fontWeight: 600, color: "var(--text-primary)" }}>
        {receipt.numero_recibo}
      </td>
      <td>
        {receipt.es_deposito_sin_identificar && !receipt.filial
          ? <span style={{ background:'rgba(249,115,22,0.15)', border:'1px solid rgba(249,115,22,0.4)',
              borderRadius:12, padding:'2px 8px', color:'#f97316', fontSize:'0.72rem', fontWeight:700 }}>
              {t("common.sinIdentificar")}
            </span>
          : (receipt.filial?.idFilial ?? "—")}
      </td>
      <td className="text-end">
        {(() => {
          const isUSD  = receipt.moneda_pago === "USD";
          const monto  = Number(receipt.monto) || 0;
          if (isUSD) {
            return (
              <span>
                <span style={{ color: "#60a5fa", fontWeight: 600 }}>
                  ${monto.toFixed(2)}
                </span>
                {receipt.monto_colones > 0 && (
                  <span style={{ display: "block", fontSize: "0.7rem", color: "var(--text-muted)" }}>
                    ≈ ₡{formatCurrency(receipt.monto_colones)}
                  </span>
                )}
              </span>
            );
          }
          if (monto === 0) {
            return (
              <span>
                <span style={{ color: "var(--text-muted)" }}>₡0.00</span>
                <span style={{
                  marginLeft: 5, fontSize: "0.68rem", fontWeight: 700,
                  background: "rgba(167,139,250,0.15)", color: "#a78bfa",
                  border: "1px solid rgba(167,139,250,0.35)",
                  borderRadius: 10, padding: "1px 6px",
                }}>
                  crédito
                </span>
              </span>
            );
          }
          return <span>₡{formatCurrency(monto)}</span>;
        })()}
      </td>
      <td>{fmtDate(receipt.fecha_pago)}</td>
      <td>{METODO_LABEL[receipt.metodo_pago] ?? receipt.metodo_pago}</td>
      <td>{receipt.cuenta_bancaria?.banco ?? "—"}</td>

      {/* Acciones */}
      <td className="text-center">
        <div style={{ display: "flex", gap: 5, justifyContent: "center" }}>
          <PillBtn
            icon="fa-pencil"
            label={t("common.editar")}
            color="#f97316"
            hoverBg="rgba(249,115,22,0.15)"
            onClick={() => onEdit?.(receipt)}
          />
          <PillBtn
            icon="fa-envelope"
            label={t("common.correo")}
            color="#60a5fa"
            hoverBg="rgba(96,165,250,0.15)"
            onClick={() => onEmail?.(receipt)}
          />
          <PillBtn
            icon={receipt.es_deposito_sin_identificar ? 'fa-rotate-left' : 'fa-trash'}
            label={receipt.es_deposito_sin_identificar ? t("common.revertir") : t("common.eliminar")}
            color="#f87171"
            hoverBg="rgba(248,113,113,0.15)"
            onClick={() => onDelete?.(receipt)}
          />
        </div>
      </td>
    </tr>
  );
}
